import { useState, useEffect } from "react";
import { useStore } from "react-redux";
import _ from "lodash";

import { Card } from '@mui/material';

import { ListDisplay } from '../../Component/ListDisplay/ListDisplay';

import { constants } from '../../Constants/constants';
import { getList } from "../../helper/baseFetch";
import { generateTableCellToMultiLanguageName } from "../../helper/util";

export const FolderMapList = ({ newFilter, editBtn, createBtn }) => {
  const store = useStore();
  const [folderMapList, setFolderMapList] = useState([]);
  const [ready, setReady] = useState(false);
  const resourceName = "FolderMap";
  const resource = constants.PATH.FOLDER.FOLDER_MAP;

  const listTitles = [
    {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "refCode",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "type",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "name",
      sort: false,
      minSize: true,
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "sequence",
      sort: true
    }, {
      key: constants.LIST_DISPLAY_TYPE.STRING,
      value: "status",
      sort: true
    }
  ];
  const listFilters = [
    {
      className: "filter-input",
      label: { resource: resourceName, key: "refCode" },
      clear: true,
      value: '',
      name: "refCode",
      size: constants.SIZE.SMALL
    },
    {
      className: "filter-input",
      label: { resource: resourceName, key: "type" },
      value: '',
      type: constants.TYPE.SELECT,
      selectValue: constants.CHOICES.FOLDER_MAP.TYPE,
      name: "type",
      size: constants.SIZE.SMALL
    },
    {
      className: "filter-input",
      label: { resource: resourceName, key: "name" },
      clear: true,
      value: '',
      name: "refName",
      size: constants.SIZE.SMALL
    },
    {
      className: "filter-input",
      label: { resource: resourceName, key: "status" },
      value: '',
      type: constants.TYPE.SELECT,
      selectValue: constants.CHOICES.FOLDER.STATUS,
      name: "status",
      size: constants.SIZE.SMALL
    }
  ];

  const [param, setParam] = useState({
    path: "",
    page: 0,
    rowsPerPage: 10,
    sort: 'updateTimestamp',
    direction: 'DESC',
    listFilters: listFilters,
    count: 0,
  })

  function onChangeParam(value) {
    value.count = value.count + 1;
    setParam(value);
  }

  function onChangeListFilters(list) {
    let tempParam = _.cloneDeep(param);
    tempParam.listFilters = list;
    tempParam.page = 0;
    onChangeParam(tempParam);
  }

  function onChangeListSort(sortItem) {
    let tempParam = _.cloneDeep(param);
    tempParam.sort = sortItem;
    tempParam.direction = tempParam.direction === "DESC" ? "ASC" : "DESC";
    onChangeParam(tempParam);
  }

  function onChangeListPage(page) {
    let tempParam = _.cloneDeep(param);
    tempParam.page = page;
    onChangeParam(tempParam);
  }

  function onChangeListRowsPerPage(rowsPerPage) {
    let tempParam = _.cloneDeep(param);
    tempParam.page = 0;
    tempParam.rowsPerPage = rowsPerPage;
    onChangeParam(tempParam);
  }

  useEffect(() => {
    let tempParam = _.cloneDeep(param);
    const filter = newFilter ? _.cloneDeep(newFilter) : {};
    tempParam.listFilters.forEach((filterItem) => {
      if (filterItem.value !== '' && filterItem.value !== undefined) {
        filter[filterItem.name] = filterItem.value;
      }
    })

    getList(resource, { sort: { field: tempParam.sort, order: tempParam.direction }, filter: filter, pagination: { page: tempParam.page + 1, perPage: tempParam.rowsPerPage } }, (payload) => {
      payload.map((item) => {
        item.name = generateTableCellToMultiLanguageName(item.refTcName, item.refEnName, item.refScName);
        return item
      });
      setFolderMapList(payload);
      setReady(true)
    }, undefined, store);

  }, [param.count]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    ready &&
    <Card className="card-wrapper overflow">
      <ListDisplay
        page={param.page}
        rowsPerPage={param.rowsPerPage}
        onChangeListSort={onChangeListSort}
        resource={resourceName}
        dataList={folderMapList}
        sort={param.sort}
        direction={param.direction}
        listTitles={listTitles}
        listFilters={param.listFilters}
        onChangeListPage={onChangeListPage}
        onChangeListRowsPerPage={onChangeListRowsPerPage}
        editBtn={editBtn}
        createBtn={createBtn}
        onChangeListFilters={onChangeListFilters}
        redirectPath={"/" + constants.PATH.FOLDER.FOLDER_MAP + "/"}
      />
    </Card>
  )
};